import React from "react";
import { Title, TitleProps, useMantineTheme } from "@mantine/core";

interface Heading4Props extends Omit<TitleProps, "order" | "styles"> {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Heading4 - Styled H4 component
 * Usage: <Heading4>Card Title</Heading4>
 */
export const Heading4: React.FC<Heading4Props> = ({
  children,
  className,
  style,
  ...props
}) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <Title
      order={4}
      className={className}
      style={{
        color: other.textPrimary,
        fontWeight: 600,
        ...style,
      }}
      {...props}
    >
      {children}
    </Title>
  );
};

export default Heading4;
